"use client"

import styles from "./Switch.module.css"

const Switch = ({ checked = false, onChange, label, disabled = false, size = "medium", ...props }) => {
  const handleChange = (e) => {
    if (disabled) return
    if (onChange) onChange(e.target.checked)
  }

  const switchClasses = [styles.switch, styles[size], checked && styles.checked, disabled && styles.disabled]
    .filter(Boolean)
    .join(" ")

  return (
    <label className={styles.container}>
      <input
        type="checkbox"
        className={styles.hiddenInput}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        {...props}
      />
      <div className={switchClasses}>
        <div className={styles.thumb}></div>
      </div>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  )
}

export default Switch
